import React, { useState } from 'react';
import { Modal, Button, Typography, message } from 'antd';
import './InvitePatientPortalModal.css';

const { Paragraph } = Typography;

const InvitePatientPortalModal = ({
  visible,
  onCancel,
  patientId,
  patientName,
  authToken,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);

  const sendInvite = async () => {
    if (!patientId) return;
    setLoading(true);
    try {
      const resp = await fetch(`${process.env.REACT_APP_API_URL}/patients/${patientId}/portal/invite`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (resp.ok) {
        try {
          const result = await resp.json();
          message.success(result.message || 'Invite sent to patient portal.');
        } catch {
          message.success('Invite sent to patient portal.');
        }
        if (onSuccess) onSuccess(patientId);
        onCancel();
      } else {
        let errMsg = 'Failed to send invite.';
        try {
          const err = await resp.json();
          errMsg = err.detail || err.message || errMsg;
        } catch {}
        message.error(errMsg);
      }
    } catch (err) {
      console.error('Invite error:', err);
      message.error('An error occurred while sending the invite.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={visible}
      title={`Invite ${patientName || 'Patient'} to Portal`}
      onCancel={onCancel}
      centered
      footer={[
        <Button key="cancel" onClick={onCancel}>
          Cancel
        </Button>,
        <Button key="send" type="primary" loading={loading} onClick={sendInvite}>
          Send Invite
        </Button>,
      ]}
      className="invite-patient-modal"
    >
      <Paragraph>
        Sending an invite will email the patient a link to register and access their patient portal.
      </Paragraph>
      <Paragraph strong>
        Patient: {patientName || '—'}
      </Paragraph>
    </Modal>
  );
};

export default InvitePatientPortalModal;